import type { DistanceStream, ElevationStream } from '../types';

// This function takes an elevation stream and a distance stream and returns an array of LatLng points.
export const getElevationFromStream = (
  elevation?: ElevationStream,
  distance?: DistanceStream
): Array<[number, number]> => {
  if (!elevation || elevation?.length === 0) {
    throw new Error('Elevation stream is empty or undefined');
  }

  if (!distance || distance?.length === 0) {
    throw new Error('Distance stream is empty or undefined');
  }

  const minLength = Math.min(elevation.length, distance.length);

  return elevation && elevation?.length > 0
    ? elevation
        ?.slice(0, minLength)
        .map(
          (elevationPoint, i) =>
            [distance?.[i] ?? null, elevationPoint] as [number, number]
        )
    : [];
};
